import React from 'react';
import { UserContext } from './contexts/UserContext';
import UserHeader from './components/UserHeader';
import UserFooter from './components/UserFooter';
import AppRoutes from './routes';
import { NavigationProvider } from './contexts/NavigationContext';
import './App.css'; // Импортируем стили

const App = () => {
  const { user } = React.useContext(UserContext);

  return (
    <NavigationProvider>
      <div id="app">
        {user && <UserHeader />}
        <main className="app-content">
          <AppRoutes />
        </main>
        {user && <UserFooter />}
      </div>
    </NavigationProvider>
  );
};

export default App;
